import ClipboardJS from 'clipboard'

export default function socialModal() {
  $(document).on('click', '.social-share', function(e){
    e.preventDefault();

    $(this).next('.social-modal').modal();
  });

  $('a.share').click(function(e){
    e.preventDefault();
    const $link = $(this),
        href = $link.attr('href');
    window.open(href, '');
  });

  const clipboard = new ClipboardJS('.copy',{
    container: document.getElementById('social-modal')
  });

  clipboard.on('success', function(e) {
    $(e.trigger).html('Copied!');
  });
}

